import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { UserInterface, setEditId, setEditError, selectUserById } from "src/store/community/usersSlice";
import { updateUser, fetchUser } from "src/actions/community/usersActions";
import { objToFormData } from "src/helpers/FormHelper";

import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";
import Form from './_partials/_Form';

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.community.users.editId);
  const error = useAppSelector(state => state.community.users.editError);
  const comment = useAppSelector(state => selectUserById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchUser(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: UserInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: UserInterface) {
    const formData = objToFormData(data);
    const resultAction = await dispatch(updateUser({ id, data: formData }));

    if (updateUser.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-comment'>
        <h6 className="v-content-label">Edit User</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={comment} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
